import React from 'react';
import { HIGHLIGHT_OPTIONS } from '../data/jobExtras';

// Tarjas da vaga (destaque + público afirmativo) exibidas no Portal do Candidato.
export const JobBadges = ({ job, className = '' }) => {
  const hl = HIGHLIGHT_OPTIONS.find((o) => o.value === job.highlight);
  const aff = job.affirmative || [];
  if (!hl && !aff.length) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {hl && <span data-testid="job-highlight-badge" className={`text-xs font-bold px-3 py-1 rounded-full shadow-sm ${hl.cls}`}>{hl.label}</span>}
      {aff.map((a, i) => (
        <span key={i} data-testid="job-affirmative-badge" className="text-xs font-semibold px-3 py-1 rounded-full bg-purple-100 text-purple-700 border border-purple-200">
          Afirmativa • {a}
        </span>
      ))}
    </div>
  );
};

// Adicionais de periculosidade/insalubridade exibidos junto ao salário.
export const JobSalaryExtras = ({ job, light = false }) => {
  const items = [];
  if (job.hazard_pay) items.push(['Periculosidade', job.hazard_value]);
  if (job.unhealthy_pay) items.push(['Insalubridade', job.unhealthy_value]);
  if (!items.length) return null;
  return (
    <div className={`space-y-0.5 text-xs font-medium ${light ? 'text-white/90' : 'text-slate-600'}`}>
      {items.map(([label, val], i) => (
        <div key={i} data-testid={`job-additional-${label.toLowerCase()}`}>+ {label}{val ? `: ${val}` : ''}</div>
      ))}
    </div>
  );
};

export default JobBadges;
